import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { ReplaySubject, takeUntil } from 'rxjs';

import Social from 'entity/Social';

import { ScootaversePageService } from '../../services/scootaverse-page.service';
import { scootaversePageSelectors } from '../../state';

import { ModalScootaversesData } from './ModalScootaversesData';

@Component({
  selector: 'modal-scootaverses',
  templateUrl: './modal-scootaverses.component.html',
  styleUrls: ['./modal-scootaverses.component.scss'],
  standalone: false,
})
export class ModalScootaversesComponent implements OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);
  public roomSets: Social[] = [];
  public loading = false;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalScootaversesData,
    public dialogRef: MatDialogRef<ModalScootaversesComponent>,
    private store: Store,
    private scootaversePageService: ScootaversePageService,
  ) {
    this.store
      .select(scootaversePageSelectors.getScootaverses)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(({ data: rooms, loading }) => {
        this.roomSets = cloneDeep(rooms);
        this.loading = loading;
      });
    this.scootaversePageService.fetchScootaverses();
  }

  public onScroll(): void {
    this.scootaversePageService.fetchMoreScootaverses();
  }

  public closeModal(): void {
    this.dialogRef.close();
  }

  public onSelectRoom(scootaverseId: string): void {
    this.dialogRef.close(scootaverseId);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
